import { all, put, takeEvery, select, takeLatest, fork, join, call } from 'redux-saga/effects';

import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { generatePath } from 'react-router';
import { submitSucceeded } from 'circe/forms/actions';
import { codeScan } from 'domain/operations/drivers/actions';
import { change, doSubmit, startSubmit, stopSubmit, reset } from 'circe/forms/actions';
import createSaga from 'domain/operations/drivers/create/saga';
import updateSaga from 'domain/operations/drivers/updateInfo/saga';

import docsSaga from 'domain/operations/drivers/docs/saga';
import itineraryStatusSaga from 'domain/operations/drivers/itineraryStatus/saga';
import { ROUTES as DRIVER_ITENRARIES_ROUTE } from 'domain/operations/drivers/itineraryStatus/constants';
import { ROUTES as DRIVER_ITENRARY_ROUTE } from 'domain/operations/drivers/itineraryStatus/view/constants';
import { createAnotherProfile } from 'domain/operations/drivers/apis';
import { CREATE_NEW_PROFILE_FORM_NAME } from 'domain/operations/drivers/constants';

function* doCodeScan(context, action) {
  try {
    const { payload } = action;
    const { data: payloadData } = payload;

    const data = JSON.parse(String(payloadData).trim());

    if (!data || typeof data !== 'object') {
      throw new Error(`invalid code ${payloadData}`);
    }

    const { type, payload: scannedPayload } = data;

    switch (type) {
      case 'DRIVER':
        if (!scannedPayload.profileId) {
          yield put(
            showNotification(I18n.str('undetectedScanDriverId', 'Unable to scan driver.'), 'error'),
          );
          return;
        }

        context.history.push(
          generatePath(DRIVER_ITENRARIES_ROUTE.ROOT, {
            driverId: scannedPayload.profileId,
          }),
        );
        break;

      case 'TRIP':
        if (!scannedPayload.tripId) {
          yield put(
            showNotification(I18n.str('undetectedScanTripId', 'Unable to scan trip .'), 'error'),
          );
          return;
        }

        context.history.push(
          generatePath(DRIVER_ITENRARY_ROUTE.ROOT, {
            itineraryId: scannedPayload.tripId,
            driverId: 'scanner',
          }),
        );
        break;
    }
  } catch (error) {
    yield put(
      showNotification(I18n.str('invalidCode', 'Unable to detect the scanned code.'), 'error'),
    );
  }
}

function* doCreateAnotherProfile(context, action) {
  if (action.payload.name !== CREATE_NEW_PROFILE_FORM_NAME) return;
  yield put(startSubmit(CREATE_NEW_PROFILE_FORM_NAME));
  const {
    payload: { values },
  } = action;

  const { profileId, companyCode, referenceId, close, fetch } = values;
  try {
    const response = yield createAnotherProfile(profileId, companyCode, referenceId);

    yield put(
      showNotification(
        I18n.str('anotherProfileCreatedSuccessfully', 'Another Profile Created Successfully'),
        'success',
      ),
    );
    yield put(stopSubmit(CREATE_NEW_PROFILE_FORM_NAME));
    yield put(reset(CREATE_NEW_PROFILE_FORM_NAME));
    close();
    fetch();
  } catch (e) {
    let message = I18n.str('error', 'Something Went Wrong, Please try again');
    if (e.code && e.code.status === 400) {
      message = e.code?.message || e.code?.error || message;
    }

    yield put(showNotification(message, 'error'));
    console.error(e);
  } finally {
    yield put(stopSubmit(CREATE_NEW_PROFILE_FORM_NAME));
  }
}
function* watcher(context) {
  yield all([
    takeEvery(codeScan().type, doCodeScan, context),
    takeEvery(doSubmit().type, doCreateAnotherProfile, context),
    docsSaga(context),
    createSaga(context),
    updateSaga(context),
    itineraryStatusSaga(context),
  ]);
}

export default watcher;
